// Customers who asked not to get automated messages. Staff can opt a number out, or back in, from here.
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api, { formatDateTime, formatPhone } from '../services/api';
import { Loader, PageHead, SearchBox } from '../components/ui';

export default function OptedOut() {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);

  const load = (query) => {
    setLoading(true);
    api
      .listOptedOut(query)
      .then((data) => setRows(Array.isArray(data) ? data : []))
      .catch((e) => toast.error(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load(q);
  }, [q]);

  const apply = async (optedOut) => {
    const value = phone.trim();
    if (!value) {
      toast.error('Enter a phone number');
      return;
    }
    setBusy(true);
    try {
      await api.setOptOutByPhone(value, optedOut);
      toast.success(optedOut ? 'Opted out' : 'Opted back in');
      setPhone('');
      load(q);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="de-fade">
      <PageHead
        title="Opted out"
        sub="Customers who asked not to get automated messages. They can still write to us, and staff can opt them back in."
      />
      <div className="de-card" style={{ marginBottom: 14 }}>
        <div className="de-row" style={{ gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <input
            className="de-input de-input--bordered"
            style={{ maxWidth: 260 }}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Phone number"
          />
          <button type="button" className="de-btn de-btn--primary" disabled={busy} onClick={() => apply(true)}>
            Opt out
          </button>
          <button type="button" className="de-btn de-btn--outline" disabled={busy} onClick={() => apply(false)}>
            Opt back in
          </button>
        </div>
      </div>
      <div className="de-row" style={{ marginBottom: 12 }}>
        <SearchBox value={q} onChange={setQ} placeholder="Search name or phone…" />
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="de-table-shell">
          <div className="de-table-wrap">
            <table className="de-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Opted out at</th>
                  <th>How</th>
                </tr>
              </thead>
              <tbody>
                {rows.length ? (
                  rows.map((r) => (
                    <tr key={r.id}>
                      <td className="de-td-strong">{r.name || '—'}</td>
                      <td>{formatPhone(r.phone)}</td>
                      <td>{formatDateTime(r.opted_out_at)}</td>
                      <td>{r.opt_out_source || '—'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="de-table-empty">
                      No opted-out customers
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
